import ApiServiceV1 from '@/api/adminApi/AdminApiV1'

export interface CustomerNotification {
  id: number
  title: string
  content: string
  isRead: boolean
  notificationType: string
  additionalData: string
  createdAt: string
}

interface NotificationsResponse {
  notifications: CustomerNotification[]
}

export class NotificationService {
  async load(page = 1, perPage = 12): Promise<CustomerNotification[]> {
    const { data } = await ApiServiceV1.get(
      `customer/notifications?per_page=${perPage}&page=${page}`
    ) as { data: NotificationsResponse }
    return data?.notifications ?? []
  }
}

export const notificationService = new NotificationService()
